// Module
var code = "<template>\n  <div show.bind=\"!edit\" class=\"dynamic-table__table-row\">\n    <slot></slot>\n  </div>\n  <div show.bind=\"edit\" class=\"dynamic-table__table-row\">\n    <slot name=\"data\"></slot>\n  </div>\n</template>\n";
// Exports
export default code;